module.exports = __webpack_public_path__ + "img/ic_checkbox_arrow.a7d28267.svg";